/** A proper "built later" card for screens whose prompt has not run yet — never a broken page. */
import { useTranslation } from 'react-i18next';
import { Card, CardContent } from './ui/card';
import { Icon } from './Icons';

export function Later({ version, body }: { version: string; body: string }) {
  const { t } = useTranslation();
  return (
    <Card>
      <CardContent className="later">
        <span className="eyebrow">
          <Icon name="clock" width={14} height={14} style={{ display: 'inline', verticalAlign: '-2px', marginRight: 6 }} />
          {t('later.title', { version })}
        </span>
        <p>{body}</p>
      </CardContent>
    </Card>
  );
}

/**
 * The top of a page: the title, with the page's buttons (the children) beside it on a wide screen and under it on a
 * phone. `lead` is the one line that says what the page is for — under the title, never beside it (1.6.2). Its
 * distance from the top bar and from the first thing under it is app.css's (`--gap-top-page`, `--gap-head-below`).
 */
export function PageHead({ title, eyebrow, id, lead, children }: { title: string; eyebrow?: string; id?: string; lead?: React.ReactNode; children?: React.ReactNode }) {
  return (
    <div className="page-head">
      <div className="page-title">
        {eyebrow ? <div className="eyebrow">{eyebrow}</div> : null}
        <h1 id={id} tabIndex={-1}>
          {title}
        </h1>
        {lead ? <p className="help lead">{lead}</p> : null}
      </div>
      {children}
    </div>
  );
}
